import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { Button, AppHeader, AppHeaderBackButton, Typography, Icon } from '@ace-clublabs/shared-component-library';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';
import { LoadingIndicator } from '../components/LoadingIndicator';
import { ClubContentName, getClubContent } from '../utils/getClubContent';
import CookieHelper from '../utils/cookieHelper';
import { Environments, getEnvironmentFromHost } from '../api/endpoints';
import member_exists_logo from '../assets/Member-Exists.png';
import { UtagType } from '../utils/UtagHelper';

export const MemberExistsPage: React.FC = () => {
  const { loadingInfo, refreshSession, sessionData, sendTag } = useContext(MembershipAppStateContext);
  const [isTagging, setIsTagging] = useState(true);
  const [isTaggingSent, setIsTaggingSent] = useState(false);
  const clubCode = CookieHelper.getClubCodeFromZipcodeCookie();
  const phoneNumber = getClubContent(ClubContentName.ContactPhoneText, clubCode);
  const couponCode = sessionData?.offerToken;

  useEffect(() => {
    refreshSession();
  }, []);

  useLayoutEffect(() => {
    if (!isTaggingSent) {
      sendTag(UtagType.view, 'knockout', { error: 'membership:join:knockout-exsting member found' });
      setIsTaggingSent(true);
    }
    setIsTagging(false);
  });

  const isLoading = loadingInfo.isLoading;
  if (isLoading) {
    return (
      <div>
        <AppHeader sx={{ padding: 0 }} />
        <LoadingIndicator loadingInfo={loadingInfo} maxSteps={0} currentStep={loadingInfo.loadingDetails.length} />
      </div>
    );
  }

  if (isTagging) {
    return <></>;
  }

  function onPhoneClick() {
    const overrides = { cta: 'membership:join:knockout-phone call' };
    sendTag(UtagType.link, 'knockout', overrides);
    window.open(`tel:${phoneNumber}`);
  }

  function onContinueAsExistingMemberClick() {
    const overrides = { cta: 'membership:join:knockout-continue as existing member' };
    const env = getEnvironmentFromHost(window.location.hostname) === Environments.prod ? '' : '-qa';
    sendTag(UtagType.link, 'knockout', overrides);
    window.open(
      `https://partnertoken${env}.aaa.com/tmobile/?couponCode=${couponCode}&area=vanity_tmobile_freeclassic`,
      '_blank'
    );
  }

  return (
    <>
      <div className="member-exists-page-view">
        <AppHeader sx={{ padding: 0 }} backButton={<AppHeaderBackButton />} />
        {loadingInfo.isLoading ? (
          <LoadingIndicator loadingInfo={loadingInfo} maxSteps={2} currentStep={loadingInfo.loadingDetails.length} />
        ) : (
          <>
            <div className="member-exists-container">
              <div className="member-exists-content-align">
                <img src={member_exists_logo} className="member-exists-icon" />
              </div>
              <Typography variant="h4" className="member-exists-title">
                We found an existing membership
              </Typography>
              <Typography variant="b1Regular" className="member-exists-description">
                If you already have a AAA membership, please try again as an existing member, or call us for assistance.
              </Typography>
              <Typography variant="h6">Customer Service hours</Typography>
              <Typography variant="b1Regular">
                Monday-Friday: 7 a.m. to 9 p.m.
                <br />
                Saturday: 8 a.m. to 5 p.m.
              </Typography>
            </div>
            <div className="member-exists-buttons">
              <Button
                label="Continue as existing member"
                fullWidth
                onClick={onContinueAsExistingMemberClick}
                variant="contained"
                size="medium"
                id="continueAsExistingMemberButton"
              ></Button>
              <Button
                className="call-club-number"
                label={`Call ${phoneNumber}`}
                variant="outlined"
                sx={{
                  color: '#1C4DA6',
                  borderColor: '#1C4DA6',
                }}
                onClick={onPhoneClick}
              ></Button>
            </div>
          </>
        )}
      </div>
    </>
  );
};
